import React from "react";
import NavBar from "../../components/navbar/NavBar";
import Footer from "../../components/footer/Footer";
import "./worldStyle.css";

const World = () => {
  return (
    <div>
      <NavBar />
      
      <div className="coming-soon-container">
        <div className="coming-soon-card">
          <div className="construction-icon">🏗️</div>
          <h1 className="coming-soon-title">Coming Soon! 即将上线!</h1>
          <p className="coming-soon-text">
            We are currently working on bringing you marathon information from around the world.
            Please check back later!
          </p>
          <p className="coming-soon-text">
            我们正在努力为您收集世界各地的马拉松信息。
            敬请期待！
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};
export default World;
